import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'

export default class extends React.Component {

  constructor(props) {
    super(props);
    this.bottomRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop >= 600) {
      this.showBottomElement(); 
    } else {
      this.hideBottomElement(); 
    }
  };

  showBottomElement() {
    if (this.bottomRef.current) {
      this.bottomRef.current.style.display = 'block'; 
    }
  }

  hideBottomElement() {
    if (this.bottomRef.current) {
      this.bottomRef.current.style.display = 'none';
    }
  }

  render() {
    return (
      <div className="ruby-ranking-bottom" ref={this.bottomRef}>
        <div className="ruby-ranking-bottom-conten">
          <div>
            <span>12</span>
            <img src="/img/app/ruby/monopoly/top3.png" alt="Ranking" />
            <div className="ruby-ranking-midle-word">
              <p>Nancy Rowe</p>
              <span>ID:5555</span>
            </div>
          </div>
          <p>99.99M</p>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// src/pages/app/ruby-monopoly/Copyright/index.js